<template>
  <div>
    <div class="flex flex-wrap items-center mb-4">
      <div class="w-full mb-2 text-stone-700 dark:text-stone-300">
        {{ t('optionsdialog.Sound') }}
      </div>
      <div class="w-full mb-2">
        <select v-model="myDuringSpinSound"
          class="w-full bg-white dark:bg-stone-700 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500 text-stone-700 dark:text-stone-200">
          <!-- Using v-for directly on the optgroup instead of the template -->
          <optgroup v-for="category in Object.keys(duringSpinSounds)" :key="category"
            :label="translateIfNeeded(category)">
            <!-- Using v-for directly on the option instead of the template -->
            <option v-for="soundName in Object.keys(duringSpinSounds[category])" :key="soundName"
              :value="duringSpinSounds[category][soundName].value">
              {{ translateIfNeeded(soundName) }}
            </option>
          </optgroup>
        </select>
      </div>
      <div class="w-full flex items-center space-x-2">
        <button @click="playDuringSpinSound" :disabled="!playbackEnabled"
          class="inline-flex items-center justify-center px-3 py-2 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm bg-white dark:bg-stone-700 text-stone-700 dark:text-stone-200 hover:bg-stone-50 dark:hover:bg-stone-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50">
          <i class="fas fa-play"></i>
        </button>
        <button @click="stopDuringSpinSound" :disabled="!playbackEnabled"
          class="inline-flex items-center justify-center px-3 py-2 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm bg-white dark:bg-stone-700 text-stone-700 dark:text-stone-200 hover:bg-stone-50 dark:hover:bg-stone-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50">
          <i class="fas fa-stop"></i>
        </button>
      </div>
    </div>
    <div class="flex flex-wrap items-center">
      <div class="w-full mb-2 text-stone-700 dark:text-stone-300">
        {{ t('optionsdialog.Volume') }}
      </div>
      <div class="w-full">
        <div class="grid grid-cols-[auto,1fr,auto] items-center gap-3">
          <span class="text-xs text-stone-500 dark:text-stone-400">0</span>
          <input type="range" v-model.number="myDuringSpinSoundVolume" min="0" max="100" step="1"
            class="w-full h-2 bg-stone-200 dark:bg-stone-700 rounded-lg appearance-none cursor-pointer accent-primary-500">
          <span class="text-xs text-stone-500 dark:text-stone-400">100</span>
        </div>
        <div class="text-right text-sm font-medium text-stone-600 dark:text-stone-400 mt-1">
          {{ myDuringSpinSoundVolume }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import * as Util from '@utils/Util.js';
import * as Audio from '@services/audio/audio.js';

const { t } = useI18n();
const emit = defineEmits(['set-during-spin-sound', 'set-during-spin-sound-volume']);
const props = defineProps({
  duringSpinSound: String,
  duringSpinSoundVolume: Number
});

const myDuringSpinSound = ref(props.duringSpinSound);
const myDuringSpinSoundVolume = ref(props.duringSpinSoundVolume);
const duringSpinSounds = Audio.getDuringSpinSounds();

const playbackEnabled = computed(() => {
  const unplayableSounds = ['no-sound', 'ticking-sound', 'random-music'];
  return !unplayableSounds.includes(myDuringSpinSound.value);
});

watch(myDuringSpinSound, (val) => emit('set-during-spin-sound', val));
watch(myDuringSpinSoundVolume, (val) => emit('set-during-spin-sound-volume', val));

function translateIfNeeded(message) {
  return message.includes('.') ? t(message) : message;
}
function playDuringSpinSound() {
  Util.trackEvent('Wheel', 'PlayDuringSpinSoundInOptionsDialog', '');
  Audio.stopMusicNow();
  Audio.startMusic(myDuringSpinSound.value, myDuringSpinSoundVolume.value);
}
function stopDuringSpinSound() {
  Util.trackEvent('Wheel', 'StopDuringSpinSoundInOptionsDialog', '');
  Audio.stopMusicNow();
}
</script>
